module.exports=function(scope){ return `{
    "meta": {
        "ok": true,
        "code": 200,
        "mode": "dev",
        "message": "The FaceMap is estimated to be 30 or over."
    },
    "data": {
        "ageEstimateGroup": 0
    }
}

<!-- NOTE: Server REST API provides additional properties for this end point. -->
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/response/success/estimate-age.json.tpl